// Copyright © 2021 Move Closer

import { Component } from 'vue-property-decorator'

import { AbstractModuleUi } from '../_abstract/ui'
import { PaywallModule } from './Paywall.contracts'

/**
 * Component capable of rendering the `Paywall's` contents.
 */
@Component<PaywallModuleUi>({
  name: 'AdBannerModuleUi',

  template: '<span class="paywall"></span>'
})
export class PaywallModuleUi extends AbstractModuleUi<PaywallModule> {
}
